export function toLowerFilter(value: string) {
  return value.toLowerCase();
}
